import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function NoteDisplay({ notes, currentNoteIndex, onSeek }) {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || currentNoteIndex < 0) return;
    const activeEl = containerRef.current.querySelector('.note-display-item.active');
    if (activeEl) {
      activeEl.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [currentNoteIndex]);

  if (!notes || notes.length === 0) {
    return <div className="note-display"><span className="note-display-empty">{t('saxTutor.noNotesLoaded')}</span></div>;
  }

  const durationSymbol = (dur) => {
    const d = (dur || '').toLowerCase();
    if (d === 'whole') return '𝅝';
    if (d === 'half') return '𝅗𝅥';
    if (d === 'quarter') return '♩';
    if (d === 'eighth') return '♪';
    if (d === '16th') return '𝅘𝅥𝅯';
    return '♩';
  };

  return (
    <div className="note-display">
      <div className="note-display-scroll" ref={containerRef}>
        {notes.map((note, i) => {
          const noteName = note.noteName || note.NoteName;
          const isRest = note.isRest || note.IsRest;
          const duration = note.duration || note.Duration || 'quarter';
          const isActive = i === currentNoteIndex;
          const isPast = i < currentNoteIndex;

          return (
            <div
              key={i}
              className={`note-display-item ${isActive ? 'active' : ''} ${isPast ? 'past' : ''} ${isRest ? 'rest' : ''}`}
              onClick={() => onSeek && onSeek(i)}
            >
              <span className="note-display-symbol">{durationSymbol(duration)}</span>
              <span className="note-display-name">{isRest ? '—' : noteName}</span>
              {note.dotCount > 0 && <span className="note-display-dot">{'·'.repeat(note.dotCount || note.DotCount || 0)}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default NoteDisplay;
